import { KYMW0F00Model } from '../kymw0f00.model';
import { GroupingDataModel } from '../vo/grouping-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * コードリストを取得する
 *
 * @export API通信成功時の処理
 * @class GetGroupingListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetGroupingListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel および Vo
  private model: KYMW0F00Model = null;
  private vo: GroupingDataModel = null;

  private successFunc: Function;

  /**
   * 選択Ｐコード
	 */
  public selectedPcode = String('');

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGroupingListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        EnableCoop142: this.vo.EnableCoop142,
        EnableCoop163: this.vo.EnableCoop163,
        EnableCoop185: this.vo.EnableCoop185,
        EnableCoop240: this.vo.EnableCoop240,
        EnableCoop210: this.vo.EnableCoop210,
        EnableCoop302: this.vo.EnableCoop302,
        EnableCoop515: this.vo.EnableCoop515,
        EnableCoop451: this.vo.EnableCoop451,
        EnableCoop454: '2', // バックエンド側でクルコ削除対応がなされたら削除、それまでは必須パラメータのため削除不可
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {CodeComboBoxModel} model
   * @param {string} codeDiv
   * @param {string} reserveNum1
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetGroupingListService
   */
  execute(model: KYMW0F00Model, vo: GroupingDataModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getGroupingList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGroupingListService
   */
  success(data: any) {
    this.model.updateGroupingList(data);

    if (this.successFunc !== null) {
      this.successFunc(this.selectedPcode);
    }
  }
}
